import { createAsyncThunk } from "@reduxjs/toolkit"

import { errorSave } from "../../../redux/errors.slice"
import { showResponseMessage } from "../../../utils/handlers/show-response-message.ts"
import { mapDeletionErrorDetails } from "../../AccountDeletionRequestsPage/api/map-deletion-error.ts"
import {
  cancelAccountDeletion,
  getDeletionStatus
} from "../../Settings/api/services.ts"
import type { SelfDeletionState } from "../types/types.ts"

type StatusPayload = Pick<
  SelfDeletionState,
  "status" | "reason_id" | "admin_comment" | "created_at" | "decided_at"
>

export const fetchSelfDeletionStatus = createAsyncThunk<StatusPayload>(
  "selfDeletion/fetchStatus",
  async (_, { rejectWithValue }) => {
    const response = await getDeletionStatus()
    if (!response.ok) {
      return rejectWithValue(response.data)
    }
    // GET is not wrapped by the backend's envelope renderer — the payload is
    // the status object itself.
    return response.data as StatusPayload
  }
)

export const cancelSelfDeletion = createAsyncThunk<void, { successMessage: string }>(
  "selfDeletion/cancel",
  async ({ successMessage }, { dispatch, rejectWithValue }) => {
    const response = await cancelAccountDeletion()
    if (!response.ok) {
      dispatch(errorSave(mapDeletionErrorDetails(response)))
      await dispatch(fetchSelfDeletionStatus())
      return rejectWithValue(response.data)
    }

    showResponseMessage({}, successMessage)
    await dispatch(fetchSelfDeletionStatus())
  }
)
